module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABJklEQVRIS2NkoDNgpLN9DHAL/585wwq2nPdnHphmZLgBptSstxLjqP+3jnqD1f1n0ADTn9kngfWbmPxG1j+AFt44Wgb1WSfURX8hNGMSmFS3WoTNp/9vHouDiP+fB5Vnhvq0HKxPw7oLuw/pbiEiDjaiuJSBAatPcfoMpp6RwR9bGkDEIb0thIXz/5tH4qFxNxe7Txlg4snEhAR6vGPkQ7pbSIRP0R1NVGqGacJZ0uDxKW0sRPj06GwoOwVbPmRgYJgFyafW6TjkUYQJlqX/b9LJQroHKd0spHu2oJuFSPXZMC1L/9O9eqK7hbA2Dd+vfGjRAG3TWG0hpgT5f+uYD1QdpE3ziW0iuAQi2Kahl4XE+IIaagiWpdSwBGsjitoG4zKP7j4EAB+n4B0Z8ZTQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/public/ancientBooks/esc_cion@2x.png
// module id = /Sah
// module chunks = 1